import type { TypeFormFieldElement } from '../../../types/form';

// ----------------------------------------------------------------------------

function isFormFieldElement(element: Element | null): element is TypeFormFieldElement {
    return (
        element instanceof HTMLInputElement ||
        element instanceof HTMLSelectElement ||
        element instanceof HTMLTextAreaElement
    );
}

// ----------------------------------------------------------------------------

export default isFormFieldElement;
